import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { droneImage } from '../../data/mock';

const AboutSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative">
              {/* Main Image */}
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_e5574598-9882-4c0d-a82a-daa0265bfbb4/artifacts/5l74gfb5_IMG-20260103-WA0000.jpg"
                  alt="Nettoyage de coque avec drone Keelcrab"
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              À propos de notre service
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Une technologie de nettoyage
              <span className="text-blue-600"> révolutionnaire</span>
            </h2>
            
            <p className="text-slate-600 mb-6 leading-relaxed">
              Notre entreprise utilise le <strong className="text-slate-800">robot Keelcrab Pro</strong>, équipé d'un filtre de 160 microns qui retient efficacement les déchets, évitant tout rejet dans l'eau.
            </p>
            
            <p className="text-slate-600 mb-8 leading-relaxed">
              Grâce à cette technologie respectueuse des normes environnementales les plus strictes, combinée à une caméra embarquée pour une inspection précise, nous garantissons un entretien écologique et performant de votre coque sur les lacs de Suisse romande.
            </p>

            {/* Features List */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                'Filtre 160 microns',
                'Caméra HD intégrée',
                'Zéro rejet polluant',
                'Intervention rapide'
              ].map((feature, idx) => (
                <div key={idx} className="flex items-center gap-3 bg-slate-50 px-4 py-3 rounded-xl">
                  <div className="w-2 h-2 bg-blue-600 rounded-full" />
                  <span className="text-sm font-medium text-slate-700">{feature}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold gap-2 group"
            >
              En savoir plus sur notre entreprise
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
